import Env from "../base/env";
import Channels from "../base/channels";
import Component from "gia/Component";
import gsap from "gsap";
import Splide from "@splidejs/splide";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger, SplitText);
import { InteractiveModuleRevealText } from "../fx/Common";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.slideshow = this.ref.slideshow[0];
    this.DOM.anchorInTheFlow = this.DOM.view.parentElement.querySelector(
      ".interactive-slideshow-anchor"
    );
    //
    this.animTexts = [];
    //! VARS
    this.VARS = {};
    this.VARS.PADDING_CIRCLE = 200;
    this.VARS.FEATURES_SIZE = 15;
    this.VARS.NEW_SLIDE = 0;
    this.VARS.CURRENT_SLIDE = -1;
    this.VARS.SLIDE_ACTIVE = false;
    this.VARS.SIZE_SCROLL = 2000;
    this.VARS.TOTAL_SEQ = this.options.totalSequence - 1;
    this.VARS.PATH_SEQ = this.options.sequencePath;
    this.TOTAL_SLIDES = this.ref.step.length - 1;
    this.VARS.IS_ANIMATING = false;
    //! Fns
    this.prepareTexts();
    this.makeSlideshow();
    this.makeSticky();
    this.events();
  }

  animateText() {
    if (
      this.VARS.NEW_SLIDE != this.VARS.CURRENT_SLIDE &&
      this.VARS.IS_ANIMATING == false
    ) {
      const DOM = this.animTexts[this.VARS.NEW_SLIDE].DOM;
      const FX = this.animTexts[this.VARS.NEW_SLIDE].FX;
      this.VARS.IS_ANIMATING = true;
      InteractiveModuleRevealText(DOM, FX, () => {
        this.VARS.IS_ANIMATING = false;
      });
    }
  }

  events() {
    for (const [i, anchor] of this.ref.anchor.entries()) {
      anchor.addEventListener("click", () => {
        this.moveScroll(i);
      });
    }
  }

  go() {
    this.reset();
    this.ref.step[this.VARS.NEW_SLIDE].classList.add("is-active");
    this.ref.anchor[this.VARS.NEW_SLIDE].classList.add("is-active");
    this.ref.progress[this.VARS.NEW_SLIDE].classList.add("is-active");
    this.ref.reminder[this.VARS.NEW_SLIDE].classList.add("is-active");
    this.animateText();
    gsap.delayedCall(0.2, () => {
      this.slideshow.go(this.VARS.NEW_SLIDE);
    });

    // }, 200);
    this.VARS.CURRENT_SLIDE = this.VARS.NEW_SLIDE;
  }

  listener(st) {
    let steps = [];
    const limit = 1 / this.ref.anchor.length;
    for (const [i, item] of this.ref.anchor.entries()) {
      const limitMin = i * limit;
      const limitMax = (i + 1) * limit;
      if (st.progress >= limitMin && st.progress < limitMax) {
        this.VARS.NEW_SLIDE = i;
      }
    }
  }

  makeSlideshow() {
    this.slideshow = new Splide(this.DOM.slideshow, {
      arrows: false,
      gap: 0,
      interval: 7000,
      padding: 0,
      pauseOnFocus: false,
      pauseOnHover: false,
      pagination: false,
      fixedWidth: "100vw",
      fixedHeight: "100vh",
      perPage: 1,
      perMove: 1,
      rewind: true,
      rewindByDrag: true,
      speed: 500,
      type: "fade",
      // omitEnd: true,
      easing: "cubic-bezier( 0.66, 0.00, 0.34, 1.00)",
      breakpoints: {
        640: {
          arrows: false,
          pagination: true,
          // omitEnd: false,
          // fixedWidth:'83%',
          autoWidth: true,
          // fixedHeight: "33vh", // previous height before souhait merdique de client
          fixedHeight: "100vh",
        },
      },
    });

    this.slideshow.mount();
  }

  makeSticky() {
    this.sticky = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: "top top",
      end: `+=${this.VARS.SIZE_SCROLL}px`,
      pin: true,
      pinSpacing: true,
      invalidateOnRefresh: true,
      onUpdate: (e) => {
        this.listener(e);
        if (this.VARS.NEW_SLIDE != this.VARS.CURRENT_SLIDE) {
          this.go();
        }
        gsap.set(this.ref.progression, {
          transformOrigin: "left top",
          scaleX: e.progress,
        });
      },
      onEnter: () => {
        this.DOM.view.classList.remove("is-disabled");
        // Channels.emit('skin::remove::dark')
      },
      onEnterBack: () => {
        this.DOM.view.classList.remove("is-disabled");
        // Channels.emit('skin::remove::dark')
      },
      onLeaveBack: () => {
        this.DOM.view.classList.add("is-disabled");
        this.resetWhenOutside();
        // Channels.emit('skin::add::dark')
      },
      onLeave: () => {
        this.DOM.view.classList.add("is-disabled");
        // Channels.emit('skin::add::dark')
        this.resetWhenOutside();
      },
    });
  }

  moveScroll(index) {
    const posY =
      this.DOM.anchorInTheFlow.getBoundingClientRect().top +
      Env.framework.toolbox.scrollPosition().scrollY;
    const ratioMove = this.VARS.SIZE_SCROLL / (this.ref.anchor.length - 1);
    const offset =
      typeof this.ref.anchor[index].getAttribute("data-offset") != "undefined"
        ? this.ref.anchor[index].getAttribute("data-offset") * 1
        : 0;
    gsap.to(window, {
      scrollTo: ratioMove * index + posY + offset,
      duration: 1.2,
      ease: "quint.inOut",
    });
    console.log(index);
  }

  prepareTexts() {
    for (const [i, step] of this.ref.step.entries()) {
      const DOM = {};
      const FX = {};
      DOM.item = step;
      DOM.title = DOM.item.querySelector(".title");
      DOM.desc = DOM.item.querySelector(".desc");
      DOM.bar = DOM.item.querySelector(".bar");
      FX.title = new SplitText(DOM.title, { type: "words" });
      FX.desc = new SplitText(DOM.desc, { type: "lines" });
      this.animTexts.push({
        DOM: DOM,
        FX: FX,
      });
    }
  }

  reset() {
    for (const [i, step] of this.ref.step.entries()) {
      step.classList.remove("is-active");
      this.ref.anchor[i].classList.remove("is-active");
      this.ref.progress[i].classList.remove("is-active");
      this.ref.reminder[i].classList.remove("is-active");
      step.classList.remove("is-prev");
      if (i < this.VARS.NEW_SLIDE) {
        step.classList.add("is-prev");
      }
    }
  }

  resetWhenOutside() {
    this.VARS.CURRENT_SLIDE = -1;
    this.reset();
  }

  unmount() {
    this.sticky.kill();
    this.slideshow.destroy();
  }
}
